// Joytrip upcoming tour dates.
// To add a show, append an object with this shape:
//   {
//     date: 'Aug 14 2026',           // human-readable
//     time: '8:00 PM',               // optional
//     venue: 'The Empty Bottle',     // venue name
//     city: 'Chicago, IL',           // city + state
//     ticket: 'https://...'          // optional — if absent, no ticket button shown
//   }
// Run `npm start` to preview after editing.
export const gigs = [
  {
    date: 'May 22 2026',
    time: '6:00 PM',
    venue: 'Main Stage Brewing',
    city: 'Lyons, CO',
  },
  {
    date: 'May 23 2026',
    time: '9:00 AM',
    venue: 'City Park Farmers Market',
    city: 'Denver, CO',
  },
  {
    date: 'May 23 2026',
    time: '8:00 PM',
    venue: 'Little Bear Saloon',
    city: 'Evergreen, CO',
  },
  {
    date: 'May 24 2026',
    time: '8:00 PM',
    venue: 'Skylark Lounge with Mofie and Chase Cavanaugh',
    city: 'Denver, CO',
  },
];
